import React from "react";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import DivideByUnitPrice from "../../DivideByUnitPrice";
interface QuantityDiscountCardProps {
  price: number;
  unitOfMeasure: string;
  divideByUnit: string;
  divideQuantity: number;
  headerText: string;
  headerTextClassName?: string;
  isDiscount?: boolean;
  multipleDiscountLevels?: boolean;
}
const QuantityDiscountCard = ({
  price,
  unitOfMeasure,
  divideByUnit,
  divideQuantity,
  headerText,
  headerTextClassName = "text-sm leading-4 font-semibold",
  isDiscount = false,
  multipleDiscountLevels = false
}: QuantityDiscountCardProps) => {
  return <div className={`flex items-center border border-solid border-gray-200 rounded w-full px-2 box-border ${!!divideByUnit && divideQuantity > 0 ? " py-2" : " py-4"}`} data-sentry-component="QuantityDiscountCard" data-sentry-source-file="QuantityDiscountCard.tsx">
      <div className={`flex flex-col ${multipleDiscountLevels ? "space-y-0.5" : "space-y-1.5"}`}>
        <span className={headerTextClassName}>{headerText}</span>
        <span>
          <span className="text-2xl leading-none font-bold text-red-500" data-testid={isDiscount ? "discount-price-container" : "base-price-container"}>
            {formatAsCurrency.formatIfUndefined(price)}
          </span>
          <span className="text-xs font-bold">/{unitOfMeasure}</span>
          {!!divideByUnit && divideQuantity > 0 && <DivideByUnitPrice divideByUnit={divideByUnit} divideQuantity={divideQuantity} price={price} cssClass="text-xs leading-none block" data-testid="divide-by-unit-price" />}
        </span>
      </div>
    </div>;
};
export default QuantityDiscountCard;